export const BOOLEAN_VALUE = {
    TRUE: 1,
    FALSE: 0,
} as const;

export type BooleanValue = (typeof BOOLEAN_VALUE)[keyof typeof BOOLEAN_VALUE];
